import { IdentificationClient } from '@frontend/identification/api';
import { Identification, IdentificationType } from '@frontend/identification/types';
import { useModals } from '@frontend/modal';
import { useEffect, useState } from 'react';

import { BadgeCardProps } from './badge-card.component';

export const useBadgeCard = (props: BadgeCardProps) => {
    const [badge, setBadge] = useState<Identification | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { openModal, closeModal } = useModals();
    const updateBadgeId = 'update-badge';
    const createBadgeId = 'create-badge';
    const deleteBadgeId = 'delete-badge';

    useEffect(() => {
        IdentificationClient.fetchIdentifications({ entity_id: props.entity_id, type: IdentificationType.BADGE }).then((response) => {
            if (response.results.length > 0) {
                setBadge(response.results[0]);
            } else {
                setBadge(null);
            }
            setIsLoading(false);
        });
    }, [props.entity_id]);

    return {
        badge,
        isLoading,
        openModal,
        closeModal,
        updateBadgeId,
        setBadge,
        createBadgeId,
        deleteBadgeId
    };
};
